import  React, {useState} from "react";
import {Link} from "react-router-dom";
import enFlag from "../static/img/BritishFlag.png";
import ukrFlag from "../static/img/UkrainianFlag.png";
import hackathonH1 from "../static/img/hackathonH1.jpg";
import hackathonH2 from "../static/img/hackathonH2.jpg";
import hackathonH3 from "../static/img/hackathonH3.jpg";
import hackathonH4 from "../static/img/hackathonH4.jpg";
import "./Microcredit.style.scss";

const HackathonInOdesa: React.FC = ()=> {
    const [isHovered, setIsHovered] = useState({on: false, index: 0});
    const [en, setEn] = useState(false);
    return (
        <div style={{marginTop:"30px",marginBottom:"20px"}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",marginBottom:"50px"}} >
                <Link to={"/"} className={"consortium_link"}
                      style={(isHovered.on && isHovered.index === 0) ? {color:"gray",boxShadow:"3px 3px 3px"} : {color:"white"}}
                      onMouseEnter={() => setIsHovered({on:true,index:0})}
                      onMouseLeave={() => setIsHovered({on:false,index:0})}
                >&#8592; Back</Link>
                <button className={"consortium_button"}
                        onClick={()=> setEn(!en)} >
                    {en ? <img src={ukrFlag} alt="flag"/> : <img src={enFlag} alt="flag"/>}
                </button>
            </div>
            <h1>
                {en ? "Students from Karazin University at the FRESH AIR 2026 Hackathon in Odesa " :
                    "Студенти Каразінського університету на Хакатоні FRESH AIR 2026 в Одесі "}
            </h1>
            <p style={{fontWeight:"inherit",fontSize: "20px",margin:"30px 120px 30px 120px",textAlign:"left"}}>
                {en ? (<>
                        &nbsp; &nbsp;As part of the DOMANI project, students from Karazin University’s Institute of Ecology,
                        Green Energy, and Sustainable Development participated in the international Fresh AIR 2026 hackathon,
                        which took place in Odesa April 2-4, 2026, in a hybrid format. <br/>
                        &nbsp; &nbsp;Two teams from Karazin University participated in the hackathon:<br/>
                        &nbsp; &nbsp;&nbsp; &nbsp;-	Green KaMinds (Participants: Dmytro Dolya, Daria Radchenko,
                        Anastasia Shevchenko, Denis Pegashev),<br/>
                        &nbsp; &nbsp;&nbsp; &nbsp;-	Karazin EcoPunk (Participants: Neonila Viktorova, Dmytro Laptev,
                        Gleb Parshukov, Karina Redko).<br/>
                        &nbsp; &nbsp;The teams demonstrated a high level of creativity and innovative thinking,
                        presenting diverse solutions that combine modern technologies, artificial intelligence,
                        and practical value. Each project stood out for its unique approach to solving pressing problems,
                        its focus on real-world application, and its potential for scalability.<br/>
                        &nbsp; &nbsp;Mentoring support for the teams was provided by Assoc. Prof.
                        Anastasia Klieshch, Assoc. Prof. Alina Hrechko, and Assoc. Prof. Svitlana Burchenko,
                        who actively worked with the participants, helping them structure their ideas,
                        refine their projects, and prepare them for the final presentations.
                    </>)
                    :
                    (<>
                        &nbsp; &nbsp;В рамках проєкту DOMANI студенти Каразінського ННІ екології, зеленої енергетики та
                        сталого розвитку взяли участь міжнародному хакатоні Fresh AIR 2026, який проходив в Одесі
                        з 2 по 4 квітня 2026 року у гібридному форматі. <br/>
                        &nbsp; &nbsp;У хакатоні взяли участь 2 команди від Каразінського університету:<br/>
                        &nbsp; &nbsp;&nbsp; &nbsp;-	Green KaMinds (учасники: Доля Дмитро, Радченко Дар’я,
                        Шевченко Анастасія, Пегашев Денис),<br/>
                        &nbsp; &nbsp;&nbsp; &nbsp;-	Karazin EcoPunk (учасники: Неоніла Вікторова, Лаптєв Дмитро,
                        Паршуков Гліб, Редько Карина).<br/>
                        &nbsp; &nbsp;Команди продемонстрували високий рівень креативності та інноваційного мислення,
                        презентувавши різнопланові рішення, що поєднують сучасні технології, штучний інтелект і практичну цінність.
                        Кожен проєкт вирізнявся власним підходом до вирішення актуальних проблем, акцентом на реальному
                        застосуванні та потенціалом масштабування.<br/>
                        &nbsp; &nbsp;Менторську підтримку команд забезпечували доц. Клєщ Анастасія, доц.
                        Гречко Аліна та доц. Бурченко Світлана, які активно працювали з учасниками, допомагали структурувати ідеї,
                        вдосконалювати проєкти та готувати їх до фінальних презентацій.
                    </>)
                }
            </p>

            <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px',width:"84%",margin:"0 auto"}}>
                <img src={hackathonH1} alt="training" style={{ width: '100%',height:'100%' }} />
                <img src={hackathonH2} alt="training" style={{ width: '100%',height:'100%' }} />
                <img src={hackathonH3} alt="training" style={{ width: '100%',height:'100%' }} />
                <img src={hackathonH4} alt="training" style={{ width: '100%',height:'100%' }} />
                {/*/!* <img src={training5} alt="training" style={{ width: '100%' }} />*/}
                {/*<img src={training6} alt="training" style={{ width: '100%' }} /> *!/*/}
            </div>
        </div>
    )
}
export default HackathonInOdesa;